var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccesstick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 80C45.2529 80 50.4543 78.9654 55.3073 76.9552C60.1604 74.945 64.5699 71.9986 68.2843 68.2843C71.9986 64.5699 74.945 60.1604 76.9552 55.3073C78.9654 50.4543 80 45.2529 80 40C80 34.7471 78.9654 29.5457 76.9552 24.6927C74.945 19.8396 71.9986 15.4301 68.2843 11.7157C64.5699 8.00138 60.1604 5.05501 55.3073 3.04482C50.4543 1.03463 45.2529 -7.82739e-08 40 0C29.3913 1.58081e-07 19.2172 4.21427 11.7157 11.7157C4.21427 19.2172 0 29.3913 0 40C0 50.6087 4.21427 60.7828 11.7157 68.2843C19.2172 75.7857 29.3913 80 40 80ZM38.9689 56.1778L61.1911 29.5111L54.3644 23.8222L35.2533 46.7511L25.3644 36.8578L19.08 43.1422L32.4133 56.4756L35.8533 59.9156L38.9689 56.1778Z",
    fill: "#954193"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccesstick);
export default __webpack_public_path__ + "static/media/successtick.c876926f9fdc389d52aeb8be1ee33fe9.svg";
export { ForwardRef as ReactComponent };